import * as THREE from 'three';
import { RoundedBoxGeometry } from 'three/addons/geometries/RoundedBoxGeometry.js';
import { box } from './products';

export function addLuxuryArchitecture(scene, materials) {
  const { architecturalTrim: trim, featureWall, galleryWall, brass, floorEdge } = materials;
  const architecture = new THREE.Group(); architecture.name = 'viewlux-architecture';
  scene.add(architecture);
  // Brand-green textured plaster, dark flutes and fine bronze reveals.
  box(architecture, 7.5, 5.75, .06, 0, 2.8, -8.81, featureWall);
  for (const side of [-1, 1]) {
    for (let i = 0; i < 13; i++) {
      box(architecture, .085, 5.75, .12, side * (3.95 + i * .14), 2.8, -8.78, trim);
    }
    box(architecture, .014, 5.75, .022, side * 3.78, 2.8, -8.71, brass);
    // Skirting is separate from the floor, avoiding coplanar surfaces.
    box(architecture, .04, .18, 38, side * 11.82, .025, 7.5, trim);
  }
  box(architecture, 24, .18, .08, 0, .025, -8.76, trim);
  const seat = new THREE.Mesh(new RoundedBoxGeometry(2.6, .18, .72, 3, .075), galleryWall);
  seat.position.set(0, .56, -5.9); seat.castShadow = true; architecture.add(seat);
  box(architecture, 2.75, .15, .8, 0, .405, -5.9, trim);
  for (const x of [-1.08, 1.08]) box(architecture, .09, .37, .58, x, .14, -5.9, brass);
  // A small living olive tree provides scale without obscuring the exhibits.
  const pot = new THREE.Mesh(new THREE.CylinderGeometry(.35, .27, .64, 24), floorEdge);
  pot.position.set(7.2, .25, -5.7); pot.castShadow = true; architecture.add(pot);
  const trunk = new THREE.Mesh(new THREE.CylinderGeometry(.025, .055, 1.4, 8), trim);
  trunk.position.set(7.2, 1.13, -5.7); architecture.add(trunk);
  const foliage = new THREE.MeshStandardMaterial({ color: '#626747', roughness: .86 });
  const leaves = new THREE.InstancedMesh(new THREE.SphereGeometry(1, 7, 5), foliage, 96);
  const dummy = new THREE.Object3D();
  for (let i = 0; i < 96; i++) {
    const angle = i * 2.39996, radius = .18 + ((i * 13) % 17) / 25;
    dummy.position.set(7.2 + Math.sin(angle) * radius, 1.38 + (i % 13) / 20, -5.7 + Math.cos(angle) * radius);
    dummy.scale.set(.15, .035, .075); dummy.rotation.set(.4, angle, Math.sin(angle) * .4);
    dummy.updateMatrix(); leaves.setMatrixAt(i, dummy.matrix);
  }
  leaves.castShadow = true; architecture.add(leaves);
  return architecture;
}

export function trimLuxuryStation(station, width, centerX, materials) {
  // Keep the quartz top AND SD150 recess/infill unchanged; wrap only the edges.
  for (const sign of [-1, 1]) {
    box(station, width, .085, .012, centerX, -.006, sign * .629, materials.architecturalTrim);
    box(station, width, .006, .016, centerX, .046, sign * .63, materials.brass);
    box(station, .012, .085, 1.26, centerX + sign * width / 2, -.006, 0, materials.architecturalTrim);
  }
}